import Vue from 'vue'
import Router from 'vue-router'
// import Home from '@/components/Home'
// import Contests from '@/components/Contests'
// import Invitati from '@/components/Invitati'
// import Program from '@/components/Program'
// import Press from '@/components/Press'
// import Archive from '@/components/Archive'
// import Voluntar from '@/components/Voluntar'
// import Contact from '@/components/Contact'
// import Echipa from '@/components/Echipa'
// import Parteneri from '@/components/Parteneri'
// import StreetArt from '@/components/StreetArt'

const Home = () => import(/* webpackChunkName: "home" */ '@/components/Home.vue')
const Contests = () => import(/* webpackChunkName: "contest" */ '@/components/Contests.vue')
const Invitati = () => import(/* webpackChunkName: "invitati" */ '@/components/Invitati.vue')
const Program = () => import(/* webpackChunkName: "program" */ '@/components/Program.vue')
const Press = () => import(/* webpackChunkName: "press" */ '@/components/Press.vue')
const Archive = () => import(/* webpackChunkName: "archive" */ '@/components/Archive.vue')
const Voluntar = () => import(/* webpackChunkName: "voluntar" */ '@/components/Voluntar.vue')
const Contact = () => import(/* webpackChunkName: "contact" */ '@/components/Contact.vue')
const Echipa = () => import(/* webpackChunkName: "echipa" */ '@/components/Echipa.vue')
const Parteneri = () => import(/* webpackChunkName: "parteneri" */ '@/components/Parteneri.vue')
const StreetArt = () => import(/* webpackChunkName: "streetart" */ '@/components/StreetArt.vue')
const Photos = () => import(/* webpackChunkName: "streetart" */ '@/components/Photos.vue')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/about'
    },
    {
      path: '/about',
      name: 'about',
      component: Home
    },
    {
      path: '/concurs',
      name: 'concurs',
      component: Contests
    },
    {
      path: '/invitati',
      name: 'invitati',
      component: Invitati
    },
    {
      path: '/invitati/:name',
      name: 'invitati',
      component: Invitati
    },
    {
      path: '/program',
      name: 'program',
      component: Program
    },
    {
      path: '/press',
      name: 'press',
      component: Press
    },
    {
      path: '/archive',
      name: 'archive',
      component: Archive
    },
    {
      path: '/echipa',
      name: 'echipa',
      component: Echipa
    },
    {
      path: '/voluntar',
      name: 'voluntar',
      component: Voluntar
    },
    {
      path: '/parteneri',
      name: 'parteneri',
      component: Parteneri
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/streetart',
      name: 'street-art',
      component: StreetArt
    },
    {
      path: '/photos',
      name: 'photos',
      component: Photos
    }
  ],
  scrollBehavior: function (to, from, savedPosition) {
  }
})

router.beforeEach((to, from, next) => {
  !localStorage.getItem('bfLang') && localStorage.setItem('bfLang', 'RO')
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js